import * as React from 'react';
import { LinkedTaskDialogAction, useLinkedTaskDialogStateHook } from '../state/LinkedTaskDialogStateHook';
import { LinkedTaskDialogState } from '../state/LinkedTaskStateTypes';

export const LinkedTaskDialogStateContext = React.createContext<[LinkedTaskDialogState, React.Dispatch<LinkedTaskDialogAction>]>(null);

export const LinkedTaskDialogStateContextProvider = (props: any) => {
  const [state, dispatch] = useLinkedTaskDialogStateHook();

  return (
    <LinkedTaskDialogStateContext.Provider value={[state, dispatch]}>
      {props.children}
    </LinkedTaskDialogStateContext.Provider>
  );
};
